import { useSetting } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { BRAND_PAGE_PRODUCT_TILE_SPECULATION_HOVER_THRESHOLD } from "@faire/web-api--source/indigofair/settings/BRAND_PAGE_PRODUCT_TILE_SPECULATION_HOVER_THRESHOLD";

export const useSettingBrandLinkHoverThreshold = (): number => {
  return useSetting(BRAND_PAGE_PRODUCT_TILE_SPECULATION_HOVER_THRESHOLD, 5000);
};
